import { Autocomplete, Button, TextField, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import { AlertMessage } from "./messages/AlertMessage";
import { useNavigate } from "react-router-dom";

const User = () =>
{
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatpassword] = useState('');
    const [fryer, setFryer] = useState('');
    const [fryers, setFryers] = useState([]);
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    let navigate = useNavigate();
    const reload = (message) => {
        const requestOptions = {
            method: 'GET'
        };
        fetch('/api/userself', requestOptions)
        .then(r => r.json())
        .then(json => {
            setEmail(json.email);
            setUsername(json.username);
            setPassword('');
            setOldPassword('');
            setRepeatpassword('');
            setFryer({
                id: json.fryer?.id, 
                label: json.fryer === null? "Bitte auswählen": json.fryer?.name +" (" + json.fryer?.hersteller + ")"
            });
        })
        .catch(err => console.error(err));
        setSuccessMessage(message);
    }

    const loadFryers = () => {
        const requestOptions = {
            method: 'GET'
        };
        fetch('/api/public/fryers', requestOptions)
        .then(r => r.json())
        .then(j => {
            let newFryers = [];
            j.forEach((fryer) => {
                newFryers.push({id: fryer?.id, label: fryer?.name +" (" + fryer?.hersteller + ")"});
            })
            setFryers(newFryers);
        })
        .catch(err => console.error(err));
    };

    const changeUsername = evt => setUsername(evt.target.value);
    const changeEmail = evt => setEmail(evt.target.value);
    const changeOldPassword = evt => setOldPassword(evt.target.value);
    const changePassword = evt => setPassword(evt.target.value);
    const changeRepeatPassword = evt => setRepeatpassword(evt.target.value);
    const changeFryer = (evt, newValue) => setFryer(newValue);

    useEffect(() => {
        reload(null);
        loadFryers();
    }, []);

    useEffect(() => {
        if (successMessage != null) {
            setTimeout(() => setSuccessMessage(null), 5000);
        }
    }, [successMessage]);

    const handleSubmit = async () => {
        if(password !== ''){
            if(password !== repeatPassword){
                setErrorMessage('Passwörder stimmen nicht überein');
                setTimeout(() => setErrorMessage(null), 5000);
                return;
            }
        }
        setSuccessMessage(null);
        const headers = new Headers();
        headers.append('Content-Type', 'application/json')
        const requestOptions = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify({
                'username': username,
                'fryer': fryer?.id,
                'oldPassword': oldPassword,
                'password': password === ''? null:password
            })
        };
        const response = await fetch('/api/user', requestOptions);

        if(response.ok){
            reload('Speichern war erfolgreich.');
        }else{
            const json = await response.json();
            setErrorMessage(json.message);
            setTimeout(() => setErrorMessage(null), 3000);
        }
    };


    return(
        <div className="centered">
            <TextField fullWidth label="username" value={username} onChange={changeUsername}/>
            <TextField fullWidth disabled label="email" value={email} onChange={changeEmail}/>
            <TextField fullWidth label="old password" type="password" value={oldPassword} onChange={changeOldPassword}/>
            <TextField fullWidth label="new password" type="password" value={password} onChange={changePassword}/>
            <TextField fullWidth label="repeat password" type="password" value={repeatPassword} onChange={changeRepeatPassword}/>
            <Autocomplete
                fullWidth
                disablePortal
                options={fryers}
                onChange={changeFryer}
                value={fryer}
                renderInput={(params) => <TextField {...params} label="Modell" />}
            />
            <Tooltip title='Dein Fryer ist nicht in der Liste? Hier kann er hinzugefügt werden'>
                <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => navigate('/fryer')}>Fryer managen</Button>
            </Tooltip>
            <AlertMessage severity={'success'} message={successMessage} />
            <AlertMessage severity="error" message={errorMessage}/>
            <Button sx={{marginLeft:'15px !important'}} fullWidth className="custom-button-root" onClick={() => handleSubmit()}>speichern</Button>
        </div>
    );
};

export default User;